import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import './bank.scss'
import {
  Container,
  CardBody,
  Card,
  Input,
  Label,
  Form,
  Row,
  Col
} from "reactstrap";

import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateBussinessBankAccount, getBank } from "../../../live-slices/business/thunk";
import { useDispatch } from "react-redux";
import { FirebaseAuthBackend, getFirebaseBackend } from "helpers/firebase_helper";
import { useNavigate } from "react-router-dom";
import ImageViewer from "Components/Common/ImageViewer";
import MediaUploader from "Components/Common/MediaUploader";
import { Media } from "helpers/models/media.model";


const BankAccountModify = () => {
  document.title = "Bank Account | BuyPass";

  const selectuserProfile = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );
  const seller = useSelector(selectuserProfile);
  const [selectedFrontCnicImage, setSelectedFrontCnicImage] = useState<any>();
  console.log(seller)
  const [selectFrontCnicImageLoading, setSelectFrontCnicImageLoading] = useState<any>(false);

  useEffect(() => {
    dispatch(getBank());
  }, []);

  useEffect(() => {
  }, [seller]);

  const getBankData = createSelector(
    (state: any) => state.Business,
    (bank) => bank?.bank
  );
  const bank = useSelector(getBankData);


  useEffect(() => {
  }, [getBank]);

  useEffect(() => {
    if (
      seller &&
      seller.idBankDetails &&
      seller.idBankDetails.bankDocuments &&
      seller.idBankDetails.bankDocuments[0]?.url
    ) {
      setSelectedFrontCnicImage(seller.idBankDetails.bankDocuments[0].url);
    }
  }, [seller]);

  const dispatch = useDispatch<any>();
  const firebaesHelper: FirebaseAuthBackend | null = getFirebaseBackend();
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const handleFieldChange = (key: string, e: any) => {
    formik.setFieldValue(key, e.target.value);
  };
  const bankData = useSelector(getBankData);

  const handleFrontCnicImageChange = async (event: any) => {
    setSelectFrontCnicImageLoading(true);
    try {
      const file = event.target.files[0];
      if (file) {
        const res = await firebaesHelper?.uploadImage(file, "product/");
        const fileObj = getFileObj(file, res);
        setSelectedFrontCnicImage(fileObj);
        formik.setFieldValue("url", fileObj.url);
      }
    } catch (e) {
      console.error("Error uploading image:", e);
    } finally {
      setSelectFrontCnicImageLoading(false);
    }
  };

  const handleDeleteFrontCnicImage = () => {
    setSelectedFrontCnicImage(null);
  };

  const getFileObj = (file: any, url: any) => {
    return {
      url,
      metadata: {
        height: file.height || 0,
        width: file.width || 0,
        fileType: file.type || "string",
        fileFormat: file.name.split('.').pop() || "string",
        name: file.name || "string",
        duration: file.duration || 0
      },
    }
  }

  const accountNumberRegex = /^[0-9]{11,16}$/;
  const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;

  const validationSchema = Yup.object({
    accountName: Yup.string()
      .required('The field value is required'),
    accountNumber: Yup.string()
      .required('The field value is required')
      .matches(accountNumberRegex, 'Allows 16 digits'),
    // bankCode: Yup.string()
    //   .required('The field value is required'),
    Iban: Yup.string()
      .required('This field is required')
      .test('conditional-validation', 'Invalid input', function (value) {
        const { bank } = this.parent;

        if (!value) return false;

        const cleanedValue = value.replace(/\s|-/g, '');
        const phonePattern = /^(\+92|92|0)?3[0-9]{9}$/;
        const ibanPattern = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;

        const phoneOnlyBanks = ['easypaisa', 'sadapay', 'nayapay', 'jazzcash'];

        if (bank && phoneOnlyBanks.some(b => bank.toLowerCase().includes(b))) {
          return phonePattern.test(cleanedValue) || this.createError({ message: 'Enter valid phone number Start With 0 or +92' });
        } else {
          return ibanPattern.test(cleanedValue) || this.createError({ message: 'Should be Alpha numeric, 24 digits field, start with PK' });
        }
      }),

    // swift: Yup.string()
    // .required('swift is required'),
    // bankBranch: Yup.string()
    // .required('bankBranch is required'),
  });

  // const onMediaUpdate = (key: string, value: Media | Media[]) => {
  //   console.log(key, value);
  // }
  const onMediaUpdate = (key: string, value: Media | Media[]) => {
    console.log(key, value);
    if (key === 'selectedFrontCnicImage') {
      setSelectedFrontCnicImage(value);
      let url: string | undefined;
      let media: Media | undefined;
      if (Array.isArray(value)) {
        url = value[0]?.url;
        media = value[0];
      } else {
        url = value?.url;
        media = value;
      }
      if (url) {
        formik.setFieldValue('url', url);
      }
      if (media) {
        formik.setFieldValue('media', media);
      }
    }
  };

  const closeViewer = () => {
    setViewerOpen(false);
  };

  const openViewer = (imageUrl: string) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  const formik = useFormik({
    initialValues: {
      bank: seller?.idBankDetails?.bank || "",
      accountName: seller?.idBankDetails?.accountName || "",
      accountNumber: seller?.idBankDetails?.accountNumber || "",
      bankCode: seller?.idBankDetails?.bankCode || "",
      Iban: seller?.idBankDetails?.Iban || "",
      swift: seller?.idBankDetails?.swift || "",
      bankBranch: seller?.idBankDetails?.bankBranch || "",
      isBusinessAddressSame:
        seller?.idBankDetails?.isBusinessAddressSame || false,
      _id: seller?._id,
      url: seller?.idBankDetails?.bankDocuments[0].url || null,

    },
    validationSchema,
    onSubmit: (values: any) => {
      console.log("Form Submitted", values);
      dispatch(updateBussinessBankAccount({ formData: values, navigate }))


    },
  })

  const navigate = useNavigate();

  const phoneOnlyBanks = ['easypaisa', 'sadapay', 'nayapay', 'jazzcash'];

  const isPhoneBasedBank = phoneOnlyBanks.some(b =>
    formik.values.bank?.toLowerCase().includes(b)
  );

  const ibanPlaceholder = isPhoneBasedBank
    ? "Phone Number (e.g. 03XXXXXXXXX or +923XXXXXXXXX)"
    : "IBAN (ex:AA00AAAA000000000000000)";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title=" Bank Account" pageTitle="My-Account " pageTitleRoute="/my-account-setting" />
        <Form onSubmit={formik.handleSubmit}>
          <Card>
            <CardBody className="rounded-3">
              <div className="d-grid gap-3 w-50 bankFildRes" >

                <div className="formContainer" >
                  <label className="form-label" htmlFor="password-input"><span style={{ color: 'red', display: 'inline' }}>*</span> Account Title  </label>
                  <Input
                    type="text"
                    className={`form-control ${formik.touched.accountName && formik.errors.accountName
                      ? "is-invalid"
                      : ""
                      }`}
                    placeholder=""
                    id="accountName"
                    name="accountName"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("accountName", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountName}
                    data-testing-Id="accountTitleInput_bankAccountModify"
                  />
                  {formik.touched.accountName && formik.errors.accountName && (
                    <div className="invalid-feedback">
                      {formik.errors.accountName as String}
                    </div>
                  )}
                </div>



                <div className="formContainer" >
                  <label className="form-label" htmlFor="password-input"><span style={{ color: 'red', display: 'inline' }}>*</span> Bank Name</label>
                  <select
                    className="form-select mb-3"
                    onChange={(e) => {
                      handleFieldChange("bank", e);
                      formik.setFieldValue("Iban", "");
                      formik.setFieldValue("accountNumber", "");
                    }}
                    value={formik.values.bank}
                    data-testing-Id="bankNameSelect_bankAccountModify"
                  >
                    {bankData.map((bank: any, index: any) => (
                      <option key={bank._id} value={bank.value} data-testing-Id={'bankNameOption_bankAccountModify' + index}>
                        {bank.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formContainer" >
                  <label className="form-label" htmlFor="password-input"><span style={{ color: 'red', display: 'inline' }}>*</span> Account Number</label>
                  <Input
                    type="number"
                    className={`form-control ${formik.touched.accountNumber && formik.errors.accountNumber
                      ? "is-invalid"
                      : ""
                      }`}
                    placeholder="Must be between 11 and 35 characters. Only alphanumeric characters are allowed"
                    id="accountNumber"
                    name="accountNumber"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("accountNumber", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountNumber}
                    data-testing-Id="accountNumberInput_bankAccountModify"
                  />
                  {formik.touched.accountNumber && formik.errors.accountNumber && (
                    <div className="invalid-feedback">
                      {formik.errors.accountNumber as String}
                    </div>
                  )}
                </div>





                <div className="formContainer" >
                  <label className="form-label responsive-label" htmlFor="password-input"><span style={{ color: 'red', display: 'inline' }}>*</span> {isPhoneBasedBank ? "Phone Number (e.g. 03XXXXXXXXX)" : "IBAN (e.g. PK00AAAA0000000000000000)"}     </label>
                  <Input
                    type="text"
                    className={`form-control ${formik.touched.Iban && formik.errors.Iban
                      ? "is-invalid"
                      : ""
                      }`}
                    placeholder={ibanPlaceholder}
                    id="Iban"
                    name="Iban"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("Iban", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.Iban}
                    data-testing-Id="ibanInput_bankAccountModify"
                  />
                  {formik.touched.Iban && formik.errors.Iban && (
                    <div className="invalid-feedback">
                      {formik.errors.Iban as String}
                    </div>
                  )}
                </div>

                {/* <div className="formContainer" >
                  <label className="form-label" htmlFor="password-input"><span style={{ color: 'red', display: 'inline' }}>*</span> Bank Code  </label>
                  <Input
                    type="text"
                    className={`form-control ${formik.touched.bankCode && formik.errors.bankCode
                      ? "is-invalid"
                      : ""
                      }`}
                    placeholder=""
                    id="bankCode"
                    name="bankCode"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("bankCode", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankCode}
                    data-testing-Id="bankCodeInput_bankAccountModify"
                  />
                  {formik.touched.bankCode && formik.errors.bankCode && (
                    <div className="invalid-feedback">
                      {formik.errors.bankCode as String}
                    </div>
                  )}

                </div> */}

                <div className="formContainer">
                  <label className="form-label" htmlFor="password-input">
                    {" "}
                    SWIFT{" "}
                  </label>
                  <Input
                    type="text"
                    className={`form-control ${formik.touched.swift && formik.errors.swift
                        ? "is-invalid"
                        : ""
                      }`}
                    placeholder="This should match the details stated in the bank documents"
                    id="swift"
                    name="swift"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("swift", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.swift}
                    data-testing-Id="swiftInput_bankAccountModify"
                  />
                  {/* {formik.touched.swift && formik.errors.swift && (
                                      <div className="invalid-feedback">
                                        {formik.errors.swift as String}
                                      </div>
                                    )} */}
                </div>

                {/* <div >
                                <button type="button" className="btn btn-light ">Upload</button>
                                </div> */}
                <h6 className="fw-bold "> <span className="text-danger me-1">*</span>Upload Cheque Copy<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>

                <MediaUploader
                  onMediaUpdate={(value) => onMediaUpdate('selectedFrontCnicImage', value)}
                  isMultiple={false}
                  initialMedia={seller.idBankDetails.bankDocuments}
                />
                {/* <ImageViewer isOpen={isViewerOpen} imageUrl={currentImage} toggle={closeViewer} /> */}
                <div>
                  <h6 className="fw-bold ">
                    {" "}
                    Branch Name{" "}
                    <span>
                      <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                    </span>
                  </h6>
                  <Input
                    type="text"
                    className={`form-control ${formik.touched.bankBranch && formik.errors.bankBranch
                        ? "is-invalid"
                        : ""
                      }`}
                    placeholder=""
                    id="bankBranch"
                    name="bankBranch"
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleFieldChange("bankBranch", e);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankBranch}
                    data-testing-Id="branchNameInput_bankAccountModify"
                  />
                  {/* {formik.touched.bankBranch && formik.errors.bankBranch && (
                                      <div className="invalid-feedback">
                                        {formik.errors.bankBranch as String}
                                      </div>
                                    )} */}
                </div>
              </div>
            </CardBody>
          </Card>
          <Card>
            <CardBody className="submit-down rounded-3 d-flex justify-content-end wi-100">
              {/* <p>By clicking "Submit", I confirm I have read, understood and agreed to the terms and conditions of <span className="text-primary">Alipay MS Terms and Conditions, Alipay Privacy Policy for Merchant Services</span> and <span className="text-primary">Alipay Merchant Acquisition Services Agreement.</span></p> */}
              <div className="left-align-button  d-flex h-25">
                <Link to="/bank-account" className="  ">
                  <button type="button" className="btn btn-outline-secondary  me-2" data-testing-Id="cancelbutton_bankAccountModify">Cancel</button>
                </Link>
                <button type="submit" className="btn btn-secondary ms-auto" data-testing-Id="submitbutton_bankAccountModify">Submit</button>

              </div>
            </CardBody>
          </Card>
        </Form>
      </Container>
    </div>
  );
};

export default BankAccountModify;
